export default "__VITE_ASSET__DqC143lV__"